/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MstTransportTypeUpdateBase
 */
export interface MstTransportTypeUpdateBase {
    /**
     * 
     * @type {boolean}
     * @memberof MstTransportTypeUpdateBase
     */
    deleteFlg?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof MstTransportTypeUpdateBase
     */
    insertDatetime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstTransportTypeUpdateBase
     */
    insertUser?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstTransportTypeUpdateBase
     */
    updateDatetime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstTransportTypeUpdateBase
     */
    updateUser?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstTransportTypeUpdateBase
     */
    deleteDatetime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstTransportTypeUpdateBase
     */
    deleteUser?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstTransportTypeUpdateBase
     */
    transportTypeId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstTransportTypeUpdateBase
     */
    companyId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstTransportTypeUpdateBase
     */
    transportTypeName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstTransportTypeUpdateBase
     */
    maxWeight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstTransportTypeUpdateBase
     */
    maxPalletCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstTransportTypeUpdateBase
     */
    remarks?: string | null;
}

/**
 * Check if a given object implements the MstTransportTypeUpdateBase interface.
 */
export function instanceOfMstTransportTypeUpdateBase(value: object): value is MstTransportTypeUpdateBase {
    return true;
}

export function MstTransportTypeUpdateBaseFromJSON(json: any): MstTransportTypeUpdateBase {
    return MstTransportTypeUpdateBaseFromJSONTyped(json, false);
}

export function MstTransportTypeUpdateBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MstTransportTypeUpdateBase {
    if (json == null) {
        return json;
    }
    return {
        
        'deleteFlg': json['delete_flg'] == null ? undefined : json['delete_flg'],
        'insertDatetime': json['insert_datetime'] == null ? undefined : (new Date(json['insert_datetime'])),
        'insertUser': json['insert_user'] == null ? undefined : json['insert_user'],
        'updateDatetime': json['update_datetime'] == null ? undefined : (new Date(json['update_datetime'])),
        'updateUser': json['update_user'] == null ? undefined : json['update_user'],
        'deleteDatetime': json['delete_datetime'] == null ? undefined : (new Date(json['delete_datetime'])),
        'deleteUser': json['delete_user'] == null ? undefined : json['delete_user'],
        'transportTypeId': json['transport_type_id'] == null ? undefined : json['transport_type_id'],
        'companyId': json['company_id'] == null ? undefined : json['company_id'],
        'transportTypeName': json['transport_type_name'] == null ? undefined : json['transport_type_name'],
        'maxWeight': json['max_weight'] == null ? undefined : json['max_weight'],
        'maxPalletCount': json['max_pallet_count'] == null ? undefined : json['max_pallet_count'],
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
    };
}

export function MstTransportTypeUpdateBaseToJSON(json: any): MstTransportTypeUpdateBase {
    return MstTransportTypeUpdateBaseToJSONTyped(json, false);
}

export function MstTransportTypeUpdateBaseToJSONTyped(value?: MstTransportTypeUpdateBase | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'delete_flg': value['deleteFlg'],
        'insert_datetime': value['insertDatetime'] == null ? value['insertDatetime'] : value['insertDatetime'].toISOString(),
        'insert_user': value['insertUser'],
        'update_datetime': value['updateDatetime'] == null ? value['updateDatetime'] : value['updateDatetime'].toISOString(),
        'update_user': value['updateUser'],
        'delete_datetime': value['deleteDatetime'] == null ? value['deleteDatetime'] : value['deleteDatetime'].toISOString(),
        'delete_user': value['deleteUser'],
        'transport_type_id': value['transportTypeId'],
        'company_id': value['companyId'],
        'transport_type_name': value['transportTypeName'],
        'max_weight': value['maxWeight'],
        'max_pallet_count': value['maxPalletCount'],
        'remarks': value['remarks'],
    };
}

